import React from "react";
import { Div, Text, Image, Button } from "atomize";
import InnerHTML from "../../utilities/innerHtml";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import PrimaryButton from "../common/PrimaryButton";
import ImageLink from "../common/ImageLink";

import { updateActiveCampaignForm } from "../../utilities/helpers";

const SubscribeNewsletter = ({ form, subscribeContent }) => {
  return (
    <Div>
      <WebsiteContainer>
        <CustomContainer
          p={{ x: { xs: "0", sm: "2.5rem" }, t: { xs: "0", md: "3.6rem" } }}
        >
          <Div
            bg="linear-gradient(223.53deg, #E139C2 1.13%, #6F56FF 65.69%, #4C75F2 98.7%)"
            p="2rem 2rem 2.5rem"
          >
            <Div maxW="38.5rem" w="100%" m="0 auto" textAlign="center">
              <Image
                src="/images/DTC_Desktop.png"
                h="4rem"
                w="4rem"
                m={{ b: "1rem" }}
              />
              <Text
                textSize="subheader6"
                textWeight="700"
                textColor="white"
                textAlign="center"
                maxW="32.125rem"
                m="auto"
                style={{ lineHeight: "1.9rem" }}
              >
                {/* {subscribeContent.formTitle} */}
                Subscribe to our DTC Podcast and join our community to learn
                from the best ecommerce founders
              </Text>
              {/* <Text
                textSize="heading3"
                textWeight="500"
                textColor="white"
                textAlign="center"
              >
                {subscribeContent.formSubtitle}
              </Text> */}
              <Div m={{ t: "1.55rem", x: "auto" }} maxW="25rem">
                {typeof window !== "undefined" && <InnerHTML html={form} />}
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    </Div>
  );
};

export default SubscribeNewsletter;
